<script setup>
import { ref } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import TeamActions from 'dashboard/components/widgets/conversation/conversationBulkActions/TeamActions.vue';
import TicketAgentSelector from './TicketAgentSelector.vue';

const props = defineProps({
  ticketCount: { type: Number, required: true },
  allTicketsSelected: { type: Boolean, default: false },
});

const emit = defineEmits(['assignTeam', 'assignAgent']);

const showTeamsList = ref(false);
const showAgentsList = ref(false);

const toggleTeamsList = () => {
  showAgentsList.value = false;
  showTeamsList.value = !showTeamsList.value;
};

const toggleAgentsList = () => {
  showTeamsList.value = false;
  showAgentsList.value = !showAgentsList.value;
};

const onAssignTeam = team => {
  emit('assignTeam', team);
  showTeamsList.value = false;
};

const onAssignAgent = agent => {
  emit('assignAgent', agent);
  showAgentsList.value = false;
};
</script>

<template>
  <div class="p-3 relative border-b border-solid border-n-strong dark:border-n-weak">
    <div class="flex items-center justify-between">
      <span class="cursor-default text-xs">
        {{ $t('BULK_ACTION.TICKETS_SELECTED', { ticketCount }) }}
      </span>
      <div class="flex items-center gap-1 bulk-action__actions relative">
        <NextButton
          v-tooltip="$t('BULK_ACTION.ASSIGN_AGENT_TOOLTIP')"
          icon="i-lucide-user-round-plus"
          slate
          xs
          faded
          @click="toggleAgentsList"
        />
        <NextButton
          v-tooltip="$t('BULK_ACTION.ASSIGN_TEAM_TOOLTIP')"
          icon="i-lucide-users-round"
          slate
          xs
          faded
          @click="toggleTeamsList"
        />
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition duration-100 ease-out"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <TicketAgentSelector
            v-if="showAgentsList"
            :ticket-count="ticketCount"
            class="[--triangle-position:1.75rem]"
            @select="onAssignAgent"
            @close="showAgentsList = false"
          />
        </transition>
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition duration-100 ease-out"
          leave-from-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <TeamActions
            v-if="showTeamsList"
            class="[--triangle-position:0.125rem]"
            @assign-team="onAssignTeam"
            @close="showTeamsList = false"
          />
        </transition>
      </div>
    </div>
    <div
      v-if="allTicketsSelected"
      class="bg-n-amber-3 text-n-amber-12 rounded text-xs mt-2 py-1 px-2 border border-solid border-n-amber-5"
    >
      {{ $t('BULK_ACTION.ALL_TICKETS_SELECTED_ALERT') }}
    </div>
  </div>
</template>

